import { SceneItem, Source } from '../obs';
import { Node } from './node';
import { type ISlotContext } from './slots';

interface ISchema {
  type: 'smart_browser_source';
  settings: {
    shutdown: boolean;
    // Desktop uses this to "map to browser source on the background"
    __remappedType: 'browser_source';
    // TODO: how to handle property editing in plugin, if needed
    propertiesManager: 'smart_browser_source';
    width: number;
    height: number;
    // 5 in overlays, this an OBS enum we could map at some point
    webpage_control_level: number;
    url: string;
  };
}

/*
 * We do not know what's deployed on reactive-sources.streamlabs.com, nor do we
 * seem to have a way to verify, in addition to that, SL Desktop has added code
 * that hijacks an overlay's browser source URL to force this domain. We will
 * just follow this behavior on plugin, except we go scorched earth and
 * replace *any* host with the desired domain. Until proven wrong there are no
 * other URLs that would host this Rive component, so why bother.
 *
 * This might pin it to the `v2` branch of this repo (again, deployment unconfirmed):
 * https://github.com/twitchalerts/rive-smart-source-wrapper
 */
const REACTIVE_SOURCES_BASE_HOST =
  'v2-sl-dynamic-overlays-demo.streamlabs.workers.dev';

export class SmartBrowserNode extends Node<ISchema, ISlotContext> {
  schemaVersion = 1;

  async load(context: ISlotContext) {
    if (!this.data) return;

    const {
      shutdown,
      width,
      height,
      webpage_control_level,
      url: originalUrl,
      propertiesManager,
    } = this.data.settings;

    console.debug('smartBrowserSource.originalUrl', originalUrl);

    const url = new URL(originalUrl);
    url.host = REACTIVE_SOURCES_BASE_HOST;

    await Source.create('browser_source', context.name, {
      width,
      height,
      shutdown,
      webpage_control_level,
      propertiesManager,
      url: url.toString(),
    });

    context.item = SceneItem.find(context.scene.name, context.name);
  }
}
